import React from 'react'
import { Text } from 'components/ds'
type Props = {
  text: string
  className?: string
}

/**
 * Instruction component for displaying centered instructional text in login forms
 * Simple text component with center alignment for user guidance
 * @param text - Instruction text to display
 * @param className - Optional CSS class for additional styling
 */
const Instruction = ({ text, className }: Props): React.ReactNode => (
  <Text as="p" align="center" className={className}>
    {text}
  </Text>
)

export default Instruction
